<template>
  <div
    v-if="maintenanceRemovalsTimelinePermission"
    class="asc-removals-timeline-template"
  >
    <asc-container class="asc-removals-timeline-container mt-4">
      <template slot="header">
        <asc-surface-title title="Removals Timeline (Beta)" />
      </template>
      <template slot="subheader">
        <asc-surface-support-text
          text="Click and drag the cursor to zoom in on the x-axis."
        />
      </template>
      <asc-removals-timeline-wrapper
        :removals-data="removalsData"
        :removals-filter-fields="removalsFilterFields"
        :filter-lookups="filterLookups"
        :on-filters-submit="onFiltersSubmit"
      ></asc-removals-timeline-wrapper>
    </asc-container>
  </div>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscSurfaceSupportText from '@/components/atoms/AscSurfaceSupportText'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import { AscRemovalsTimelineWrapper } from '@/components/organisms'

export default {
  name: 'AscRemovalsTimelineTemplate',

  components: {
    AscContainer,
    AscSurfaceTitle,
    AscSurfaceSupportText,
    AscRemovalsTimelineWrapper,
  },

  props: {
    removalsData: {
      type: Array,
      default: () => [],
    },
    onFiltersSubmit: {
      type: Function,
      default: () => {},
    },
    removalsFilterFields: {
      type: Array,
      default: () => [],
    },
    filterLookups: {
      type: Array,
      default: () => [],
    },
    maintenanceRemovalsTimelinePermission: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
